import { render, staticRenderFns } from "./ModalForgotPin.vue?vue&type=template&id=36f39020&"
import script from "./ModalForgotPin.vue?vue&type=script&lang=js&"
export * from "./ModalForgotPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports